
export { HighlightDisplayLogic } from "./highlightSection.interfaces"
export { SectionItemType } from "./thumbnailSection.interfaces"